import {
  LIST_PUBLICATIONS,
  DELETE_PUBLICATION,
  ADD_PUBLICATION,
} from '../actions/publicationsActions';
import {
  ApiPublicationListType,
  ApiPublicationType,
} from '../features/Publications/types';

export type PublicationListType = {
  items: ApiPublicationListType;
  total: number;
};

export type PublicationReducerActionType = {
  type: string;
  payload: PublicationListType | ApiPublicationType | string;
};

const defaultState = {
  items: [],
  total: 0,
};

const publicationsReducer = (
  state = defaultState,
  action: PublicationReducerActionType
) => {
  switch (action.type) {
    case LIST_PUBLICATIONS:
      return action.payload;
    case ADD_PUBLICATION:
      return {
        ...state,
        items: [action.payload, ...state.items],
      };
    case DELETE_PUBLICATION:
      return {
        ...state,
        items: state.items.filter(
          ({ id }: ApiPublicationType) => id !== action.payload
        ),
      };
    default:
      return state;
  }
};

export default publicationsReducer;
